import theme from "@/theme";

export const styles = {
  postWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "auto",
  },
  postContainer: {
    background: "white",
    width: "100%",
    position: "relative",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  headerStack: {
    marginBottom: "1rem",
    width: "100%",
  },
  userInfoStack: {
    gap: "0.5rem",
    alignItems: "center",
  },
  usernameText: {
    fontWeight: "600",
    fontSize: "18px",
    color: (theme: any) => theme.palette.custom.blueGray900,
  },
  userTimeText: {
    color: (theme: any) => theme.palette.custom.blueGray600,
    fontSize: "0.875rem",
  },
  menuItemEdit: {
    padding: "1rem 2.3rem 0.5rem 1.3314rem",
    gap: "0.25rem",
  },
  menuItemDelete: {
    padding: "0.5rem 2.3rem 1rem 1.3314rem",
    gap: "0.25rem",
  },
  menuOptionText: {
    fontSize: "1rem",
    fontWeight: 500,
  },
  imageWrapper: {
    width: "100%",
    maxHeight: "520px",
    position: "relative",
    marginBottom: "1rem",
    overflow: "hidden",
    borderRadius: "14px",
  },
  imageStyle: {
    objectFit: "cover" as const,
    width: "100%",
    maxHeight: "520px",
    borderRadius: "14px",
  },
  watermark: {
    display: "flex",
    position: "absolute",
    bottom: "15px",
    left: "10px",
    flexDirection: "row",
    gap: "10px",
  },
  logoBox: {
    width: "91px",
    height: "34px",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paidBox: {
    width: "102px",
    height: "34px",
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontWeight: 600,
    wordBreak: "break-word" as const,
    margin: 0,
  },
  bodyWrapper: {
    position: "relative",
    width: "100%",
  },
  buyButton: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    minWidth: "230px",
    maxWidth: "790px",
    height: "44px",
    borderRadius: "42px",
    padding: "10px 12px",
    gap: "8px",
    backgroundColor: theme.palette.custom.mainBlue,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 15,
    "&:hover": {
      backgroundColor: "#1F6FE0",
    },
  },
  buyButtonText: {
    textTransform: "none",
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  buyOverlay: (lineY: number) => ({
    position: "absolute" as const,
    top: `${lineY - 20}px`,
    left: "-10px",
    right: 0,
    bottom: 0,
    pointerEvents: "none" as const,
    zIndex: 5,
    width: "840px",
    backdropFilter: "blur(11px)",
    WebkitBackdropFilter: "blur(11px)",
    background: "rgba(255, 255, 255, 0.7)",
  }),
  postSelectDropdownMenu: {
    sx: {
      marginTop: "9px",
      marginLeft: "5px",
      borderRadius: "8px",
      padding: "0px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 16px 0px #0000001A",
      maxWidth: "156px",
      minWidth: "154px",
    },
  },
  btnWrapper: {
    width: 800,
    height: 84,
    transform: "rotate(0deg)",
    opacity: 1,
    paddingTop: "20px",
    paddingBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    margin: "0 auto",
  },
};
